import NavEntryLink from './NavEntryLink';
import NavSectionTrigger from './NavSectionTrigger';
import { sectionBadge } from './section-badge';
import type { NavModel } from './use-nav-model';
import type { NavFlyoutApi } from './useNavFlyout';

interface NavPanelEntriesProps {
  nav: NavModel;
  flyout: NavFlyoutApi;
  flyoutId: string;
  /** Icon-only, for the rail; otherwise the labelled rows. */
  collapsed: boolean;
}

/** Every top-level entry, in either band of the panel: links go straight to
 *  their page, sections open their pages in a fly-out. */
export default function NavPanelEntries({
  nav,
  flyout,
  flyoutId,
  collapsed,
}: NavPanelEntriesProps) {
  return (
    <>
      {nav.entries.map((entry) =>
        entry.kind === 'link' ? (
          <NavEntryLink key={entry.link.id} link={entry.link} collapsed={collapsed} />
        ) : (
          <NavSectionTrigger
            key={entry.section.id}
            section={entry.section}
            collapsed={collapsed}
            active={nav.activeSection === entry.section.id}
            open={flyout.open?.id === entry.section.id}
            flyoutId={flyoutId}
            flyout={flyout}
            badge={sectionBadge(entry.section.label, entry.items)}
          />
        ),
      )}
    </>
  );
}
